import React from "react";
import { PortfolioPage } from "../components/Portfolio/Page";

const IndexPage = (pageContext) => <PortfolioPage pageContext={pageContext} />;

export default IndexPage;
